// Centralized contact constants for Capital Automobile
export const PHONE_DISPLAY = "076 442 58 04";
export const PHONE_RAW = "+41764425804";
export const PHONE_HREF = `tel:${PHONE_RAW}`;

export const WHATSAPP_NUMBER = "41764425804";
export const WHATSAPP_TEXT = "Bonjour%2C%20je%20souhaite%20vendre%20ma%20voiture";
export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

export const EMAIL = "info@capitalautomobile.ch";
export const EMAIL_HREF = `mailto:${EMAIL}`;

export const ADDRESS = "Rte de Crochy 16, 1024 Ecublens";
export const HOURS = "Ouvert 7/7 de 7h à 22h";

export const CANTONS = [
    { name: "Vaud", slug: "vaud", short: "VD" },
    { name: "Genève", slug: "geneve", short: "GE" },
    { name: "Fribourg", slug: "fribourg", short: "FR" },
    { name: "Neuchâtel", slug: "neuchatel", short: "NE" },
    { name: "Valais", slug: "valais", short: "VS" },
];

export const NAV_LINKS = [
    { label: "Accueil", to: "/" },
    { label: "Demande d'offre", to: "/demande-offre" },
    { label: "Qui sommes-nous", to: "/qui-sommes-nous" },
    { label: "FAQ", to: "/faq" },
    { label: "Avis", to: "/avis" },
    { label: "Actualités", to: "/blog" },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1697908833194-e29be25dea12?w=1600&q=80&fm=webp&auto=format";

export const LOGO_SRC = "/assets/logo-capital.png";
